import { DialogComponent } from '@theme/dialog';
import { CartAddEvent, ThemeEvents } from '@theme/events';

const FREE_SHIPPING_THRESHOLD = 3000;

const PRODUCTS = {
  titan: {
    handle: 'titan-surge-pre-workout-fizzy-cola-bottles',
    title: 'Titan Surge Pre Workout',
    subtitle: 'Energy before training',
    image: 'https://cdn.shopify.com/s/files/1/1005/1964/1429/files/Fizzy-Cola-scaled.png?v=1765810348&width=180',
    url: '/products/titan-surge-pre-workout-fizzy-cola-bottles',
    variantId: 54179361554773,
    price: 'From £19.99',
  },
  workoutBundle: {
    handle: 'the-workout-bundle',
    title: 'The Workout Bundle',
    subtitle: 'Best for training days',
    image: 'https://cdn.shopify.com/s/files/1/1005/1964/1429/files/WorkoutBundle.png?v=1781873587&width=180',
    url: '/products/the-workout-bundle',
    variantId: 54179366633813,
    price: 'From £54.99',
    variantByTitle: {
      'Fizzy Cola Bottles': 54179366633813,
      'Pear Drops': 54179366666581,
      'Fizzy Blue Razz': 54179366699349,
      'Jelly Cherries': 54179366732117,
      'Bubblegum Flying Saucers': 54179366764885,
    },
  },
  creatine: {
    handle: 'creatine-monohydrate-500g',
    title: 'Creatine Monohydrate',
    subtitle: 'Daily strength support',
    image: 'https://cdn.shopify.com/s/files/1/1005/1964/1429/files/PN-Creatine-Render-scaled.png?v=1765795501&width=180',
    url: '/products/creatine-monohydrate-500g',
    variantId: 52090778714453,
    price: '£24.99',
  },
  eaa: {
    handle: 'eaa',
    title: 'EAA',
    subtitle: 'Intra-workout support',
    image: 'https://cdn.shopify.com/s/files/1/1005/1964/1429/files/1_e78fbda1-dcd6-4d30-949b-c8b91984c279.png?v=1767618010&width=180',
    url: '/products/eaa',
    variantId: 52205539754325,
    price: '£29.99',
  },
  hydros: {
    handle: 'hydros',
    title: 'Hydros',
    subtitle: 'Hydration support',
    image: 'https://cdn.shopify.com/s/files/1/1005/1964/1429/files/PN_Hydros_Strawberry-Kiwi_Transparent-Render.png?v=1772635412&width=180',
    url: '/products/hydros',
    variantId: 52872948154709,
    price: '£29.99',
  },
  glutamine: {
    handle: 'l-glutamine-500g',
    title: 'L-Glutamine',
    subtitle: 'Recovery support',
    image: 'https://cdn.shopify.com/s/files/1/1005/1964/1429/files/PN-Glutamine-Render-scaled.png?v=1765797175&width=180',
    url: '/products/l-glutamine-500g',
    variantId: 52090956579157,
    price: '£24.99',
  },
  triCarb: {
    handle: 'titan-tri-carb',
    title: 'Titan Tri-Carb',
    subtitle: 'Fuel longer sessions',
    image: 'https://cdn.shopify.com/s/files/1/1005/1964/1429/files/pantheon_TRI_CARB.png?v=1767618311&width=180',
    url: '/products/titan-tri-carb',
    variantId: 52205731119445,
    price: '£39.99',
  },
  performanceBundle: {
    handle: 'the-performance-bundle',
    title: 'The Performance Bundle',
    subtitle: 'Best daily stack',
    image: 'https://cdn.shopify.com/s/files/1/1005/1964/1429/files/PerformanceBundle.png?v=1781872304&width=180',
    url: '/products/the-performance-bundle',
    variantId: 54179328360789,
    price: '£59.99',
  },
  recoveryBundle: {
    handle: 'the-recovery-bundle',
    title: 'The Recovery Bundle',
    subtitle: 'Best recovery stack',
    image: 'https://cdn.shopify.com/s/files/1/1005/1964/1429/files/RecoveryBundle.png?v=1781871752&width=180',
    url: '/products/the-recovery-bundle',
    variantId: 54179310076245,
    price: '£46.99',
  },
  hybridBundle: {
    handle: 'hybrid-bundle',
    title: 'The Hybrid Bundle',
    subtitle: 'Best all-round stack',
    image: 'https://cdn.shopify.com/s/files/1/1005/1964/1429/files/HybridBundle.png?v=1781870439&width=180',
    url: '/products/hybrid-bundle',
    variantId: 54178972959061,
    price: 'From £71.99',
  },
  jug: {
    handle: 'xxl-2-2-ltr-jug',
    title: 'XXL 2.2 Ltr Jug',
    subtitle: 'Training day essential',
    image: 'https://cdn.shopify.com/s/files/1/1005/1964/1429/files/Pantheon-Water-Bottle-Render_Angle-2_1.png?v=1765811108&width=180',
    url: '/products/xxl-2-2-ltr-jug',
    variantId: 52093046423893,
    price: '£14.99',
  },
  zmb: {
    handle: 'zmb',
    title: 'ZMB',
    subtitle: 'Night-time recovery support',
    image: 'https://cdn.shopify.com/s/files/1/1005/1964/1429/files/PN_ZMB-2_b4d33ef3-33ad-48e3-9d10-bb63ff1221a6.png?v=1769701987&width=180',
    url: '/products/zmb',
    variantId: 52393901228373,
    price: '£14.99',
  },
  iron: {
    handle: 'iron',
    title: 'Iron',
    subtitle: 'Low-cost daily add-on',
    image: 'https://cdn.shopify.com/s/files/1/1005/1964/1429/files/PN_IRON.png?v=1769524955&width=180',
    url: '/products/iron',
    variantId: 52359458881877,
    price: '£9.99',
  },
  vitaminC: {
    handle: 'vitamin-c',
    title: 'Vitamin C',
    subtitle: 'Daily health add-on',
    image: 'https://cdn.shopify.com/s/files/1/1005/1964/1429/files/PN_VITAMIN-C.png?v=1769524229&width=180',
    url: '/products/vitamin-c',
    variantId: 52359452492117,
    price: '£19.99',
  },
  d3k2: {
    handle: 'd3-k2',
    title: 'D3 & K2',
    subtitle: 'Daily wellness support',
    image: 'https://cdn.shopify.com/s/files/1/1005/1964/1429/files/PN_D2K2.png?v=1769174725&width=180',
    url: '/products/d3-k2',
    variantId: 52316707619157,
    price: '£19.99',
  },
  ashwagandha: {
    handle: 'ashwagandha-ksm-66',
    title: 'Ashwagandha KSM-66',
    subtitle: 'Calm and recovery support',
    image: 'https://cdn.shopify.com/s/files/1/1005/1964/1429/files/PN_Ashwagandha_Straight_Render-scaled.png?v=1765794941&width=180',
    url: '/products/ashwagandha-ksm-66',
    variantId: 52090726187349,
    price: '£19.99',
  },
  hypnos: {
    handle: 'hypnos',
    title: 'Hypnos',
    subtitle: 'Sleep support',
    image: 'https://cdn.shopify.com/s/files/1/1005/1964/1429/files/PN_HYPNOS_90cap.png?v=1769525657&width=180',
    url: '/products/hypnos',
    variantId: 52359511605589,
    price: '£29.99',
  },
  testus: {
    handle: 'testus-maximus',
    title: 'Testus Maximus',
    subtitle: "Men's performance support",
    image: 'https://cdn.shopify.com/s/files/1/1005/1964/1429/files/PN_TESTUS-MAXIMUS.png?v=1769091933&width=180',
    url: '/products/testus-maximus',
    variantId: 52309808415061,
    price: '£39.99',
  },
  shilajit: {
    handle: 'shilajit-capsules',
    title: 'Shilajit Capsules',
    subtitle: 'Daily vitality support',
    image: 'https://cdn.shopify.com/s/files/1/1005/1964/1429/files/PN_Shilajit_Straight_Render-scaled.png?v=1765797631&width=180',
    url: '/products/shilajit-capsules',
    variantId: 52090990068053,
    price: '£19.99',
  },
  turkesterone: {
    handle: 'turkesterone-600mg',
    title: 'Turkesterone 600mg',
    subtitle: 'Strength-focused support',
    image: 'https://cdn.shopify.com/s/files/1/1005/1964/1429/files/PN_Turkesterone_Straight_Render-scaled.png?v=1765810994&width=180',
    url: '/products/turkesterone-600mg',
    variantId: 52093038821717,
    price: '£27.99',
  },
};

const SINGLE_PRODUCT_UPGRADES = [
  { triggers: [PRODUCTS.titan.handle], product: PRODUCTS.workoutBundle, title: 'Upgrade to the full stack', text: 'Get the products that work together and save compared with buying separately.', button: 'Upgrade my stack' },
  { triggers: [PRODUCTS.creatine.handle, PRODUCTS.eaa.handle], product: PRODUCTS.performanceBundle, title: 'Upgrade to the full stack', text: 'Get the full daily stack for strength, hydration and performance.', button: 'Upgrade my stack' },
  { triggers: [PRODUCTS.hydros.handle, PRODUCTS.triCarb.handle], product: PRODUCTS.hybridBundle, title: 'Upgrade to the full stack', text: 'Build a stronger training setup for hydration, endurance and performance.', button: 'Upgrade my stack' },
  { triggers: [PRODUCTS.glutamine.handle], product: PRODUCTS.recoveryBundle, title: 'Recover properly', text: 'Make recovery more complete with The Recovery Bundle.', button: 'Upgrade my stack' },
];

const PAIR_UPSELLS = [
  { has: [PRODUCTS.creatine.handle, PRODUCTS.eaa.handle], product: PRODUCTS.hydros, title: 'Complete your stack', text: "You're one product away from a complete stack.", button: 'Add to stack' },
  { has: [PRODUCTS.creatine.handle, PRODUCTS.hydros.handle], product: PRODUCTS.eaa, title: 'Complete your stack', text: "You're one product away from a complete stack.", button: 'Add to stack' },
  { has: [PRODUCTS.eaa.handle, PRODUCTS.hydros.handle], product: PRODUCTS.creatine, title: 'Complete your stack', text: "You're one product away from a complete stack.", button: 'Add to stack' },
  { has: [PRODUCTS.titan.handle, PRODUCTS.eaa.handle], product: PRODUCTS.hydros, title: 'Complete your workout stack', text: 'Add hydration support to round out the session.', button: 'Add to stack' },
  { has: [PRODUCTS.titan.handle, PRODUCTS.hydros.handle], product: PRODUCTS.eaa, title: 'Complete your workout stack', text: 'Add intra-workout support to round out the session.', button: 'Add to stack' },
  { has: [PRODUCTS.glutamine.handle, PRODUCTS.ashwagandha.handle], product: PRODUCTS.hypnos, title: 'Complete your recovery stack', text: "You're one product away from a stronger evening routine.", button: 'Add to stack' },
  { has: [PRODUCTS.hypnos.handle, PRODUCTS.zmb.handle], product: PRODUCTS.ashwagandha, title: 'Complete your recovery stack', text: 'Add calm and recovery support to your night-time routine.', button: 'Add to stack' },
  { has: [PRODUCTS.d3k2.handle, PRODUCTS.vitaminC.handle], product: PRODUCTS.zmb, title: 'Add another daily essential', text: 'Round out your daily support routine.', button: 'Add to stack' },
];

const LOW_COST_ADD_ONS = [PRODUCTS.jug, PRODUCTS.zmb, PRODUCTS.iron, PRODUCTS.vitaminC, PRODUCTS.d3k2, PRODUCTS.ashwagandha];
const JUG_TRIGGERS = [PRODUCTS.hydros.handle, PRODUCTS.eaa.handle, PRODUCTS.titan.handle, PRODUCTS.triCarb.handle, PRODUCTS.hybridBundle.handle, PRODUCTS.workoutBundle.handle];

const PRODUCT_PAGE_RECOMMENDATIONS = {
  [PRODUCTS.titan.handle]: {
    title: 'Complete your workout',
    intro: 'Want the full training setup? Get Titan Surge as part of The Workout Bundle and complete your session stack.',
    primary: PRODUCTS.workoutBundle,
    cta: 'Upgrade to The Workout Bundle',
    items: [PRODUCTS.eaa, PRODUCTS.hydros, PRODUCTS.creatine],
  },
  [PRODUCTS.creatine.handle]: {
    title: 'Build around creatine',
    intro: 'Creatine works best as part of a consistent daily routine. Get it inside The Performance Bundle with other everyday training essentials.',
    primary: PRODUCTS.performanceBundle,
    cta: 'Upgrade to The Performance Bundle',
    items: [PRODUCTS.eaa, PRODUCTS.hydros, PRODUCTS.titan],
  },
  [PRODUCTS.eaa.handle]: {
    title: 'Best paired with',
    intro: 'EAA is a strong intra-workout essential. Pair it with hydration and performance products in a complete stack.',
    primary: PRODUCTS.performanceBundle,
    cta: 'Shop the Performance Bundle',
    items: [PRODUCTS.hydros, PRODUCTS.creatine, PRODUCTS.jug],
  },
  [PRODUCTS.hydros.handle]: {
    title: 'Hydration stack add-ons',
    intro: 'Hydros is your hydration base. Get it inside The Hybrid Bundle for a more complete training setup.',
    primary: PRODUCTS.hybridBundle,
    cta: 'Upgrade to The Hybrid Bundle',
    items: [PRODUCTS.eaa, PRODUCTS.jug, PRODUCTS.titan],
  },
  [PRODUCTS.glutamine.handle]: {
    title: 'Support recovery further',
    intro: 'Make recovery more complete. Get L-Glutamine inside The Recovery Bundle.',
    primary: PRODUCTS.recoveryBundle,
    cta: 'Upgrade to The Recovery Bundle',
    items: [PRODUCTS.hypnos, PRODUCTS.ashwagandha, PRODUCTS.zmb],
  },
  [PRODUCTS.triCarb.handle]: {
    title: 'Fuel longer sessions',
    intro: 'For longer or harder sessions, pair your carb source with hydration and intra-workout support.',
    primary: PRODUCTS.hybridBundle,
    cta: 'Shop The Hybrid Bundle',
    items: [PRODUCTS.hydros, PRODUCTS.eaa, PRODUCTS.titan],
  },
  [PRODUCTS.workoutBundle.handle]: {
    title: 'Add recovery to your workout stack',
    intro: 'Want to go further? Add one of these to your stack.',
    items: [PRODUCTS.creatine, PRODUCTS.jug, PRODUCTS.glutamine],
  },
  [PRODUCTS.performanceBundle.handle]: {
    title: 'Add pre-workout or recovery support',
    intro: 'Build beyond the daily basics with training-day or recovery support.',
    items: [PRODUCTS.titan, PRODUCTS.glutamine, PRODUCTS.jug],
  },
  [PRODUCTS.recoveryBundle.handle]: {
    title: 'Go further with recovery',
    intro: 'Support recovery with hydration and daily performance basics.',
    items: [PRODUCTS.hydros, PRODUCTS.creatine, PRODUCTS.jug],
  },
  [PRODUCTS.hybridBundle.handle]: {
    title: 'Add strength or recovery support',
    intro: 'Round out the hybrid stack with strength and recovery essentials.',
    items: [PRODUCTS.creatine, PRODUCTS.titan, PRODUCTS.glutamine],
  },
};

class CartDrawerComponent extends DialogComponent {
  connectedCallback() {
    super.connectedCallback();
    document.addEventListener(CartAddEvent.eventName, this.#handleCartAdd);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    document.removeEventListener(CartAddEvent.eventName, this.#handleCartAdd);
  }

  #handleCartAdd = () => {
    if (this.hasAttribute('auto-open')) {
      this.showDialog();
    }
  };

  open() {
    this.showDialog();
    syncBundleUpsell();

    customElements.whenDefined('shopify-payment-terms').then(() => {
      const installmentsContent = document.querySelector('shopify-payment-terms')?.shadowRoot;
      const cta = installmentsContent?.querySelector('#shopify-installments-cta');
      cta?.addEventListener('click', this.closeDialog, { once: true });
    });
  }

  close() {
    this.closeDialog();
  }
}

if (!customElements.get('cart-drawer-component')) {
  customElements.define('cart-drawer-component', CartDrawerComponent);
}

class FreeShippingCountdown extends HTMLElement {
  connectedCallback() {
    this.render();
    document.addEventListener(CartAddEvent.eventName, this.#handleCartChange);
    document.addEventListener(ThemeEvents.cartUpdate, this.#handleCartChange);
    document.addEventListener(ThemeEvents.discountUpdate, this.#handleCartChange);
  }

  disconnectedCallback() {
    document.removeEventListener(CartAddEvent.eventName, this.#handleCartChange);
    document.removeEventListener(ThemeEvents.cartUpdate, this.#handleCartChange);
    document.removeEventListener(ThemeEvents.discountUpdate, this.#handleCartChange);
  }

  #handleCartChange = async () => {
    try {
      const response = await fetch('/cart.js');
      const cart = await response.json();

      this.dataset.cartTotal = cart.total_price;
      this.render();
    } catch (error) {
    }
  };

  render() {
    const threshold = Number(this.dataset.threshold || FREE_SHIPPING_THRESHOLD);
    const cartTotal = Number(this.dataset.cartTotal || 0);
    const remaining = Math.max(threshold - cartTotal, 0);
    const progress = Math.min((cartTotal / threshold) * 100, 100);
    const text = this.querySelector('.free-shipping-countdown__text');
    const bar = this.querySelector('.free-shipping-countdown__bar');

    const formatter = new Intl.NumberFormat('en-GB', {
      style: 'currency',
      currency: this.dataset.currency || 'GBP',
    });

    if (text) {
      text.textContent =
        remaining === 0
          ? "You've unlocked free shipping."
          : `Spend ${formatter.format(remaining / 100)} more for free shipping.`;
    }

    if (bar) {
      bar.style.width = `${progress}%`;
    }
  }
}

if (!customElements.get('free-shipping-countdown')) {
  customElements.define('free-shipping-countdown', FreeShippingCountdown);
}

class CartBundleUpsell extends HTMLElement {
  connectedCallback() {
    this.addEventListener('click', this.#handleClick);
  }

  disconnectedCallback() {
    this.removeEventListener('click', this.#handleClick);
  }

  #handleClick = async (event) => {
    const button = event.target instanceof Element ? event.target.closest('[data-upsell-add]') : null;
    if (!(button instanceof HTMLButtonElement)) return;

    const variantId = Number(button.dataset.variantId);
    if (!variantId) return;

    const originalText = button.textContent;
    button.disabled = true;
    button.textContent = 'Adding...';

    try {
      const sectionIds = Array.from(document.querySelectorAll('cart-items-component'))
        .map((item) => (item instanceof HTMLElement ? item.dataset.sectionId : null))
        .filter(Boolean);

      const response = await fetch(Theme.routes.cart_add_url || '/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
        body: JSON.stringify({
          id: variantId,
          quantity: 1,
          sections: sectionIds.join(','),
          sections_url: window.location.pathname,
        }),
      });

      const data = await response.json();

      if (!response.ok || data.status) {
        throw new Error(data.description || data.message || 'Unable to add item');
      }

      this.dispatchEvent(
        new CartAddEvent({}, String(variantId), {
          source: 'cart-upsell',
          itemCount: 1,
          variantId: String(variantId),
          sections: data.sections,
        })
      );

      button.textContent = 'Added';
      await syncBundleUpsell();
    } catch (error) {
      button.textContent = 'Try again';
    } finally {
      window.setTimeout(() => {
        button.disabled = false;
        button.textContent = originalText;
      }, 1200);
    }
  };
}

if (!customElements.get('cart-bundle-upsell')) {
  customElements.define('cart-bundle-upsell', CartBundleUpsell);
}

function getCartHandles(cart) {
  return cart.items.map((item) => item.handle).filter(Boolean);
}

function hasAll(handles, required) {
  return required.every((handle) => handles.includes(handle));
}

function findPrimaryCartOffer(cart) {
  if (!cart?.items?.length) return null;

  const handles = getCartHandles(cart);

  for (const rule of PAIR_UPSELLS) {
    if (hasAll(handles, rule.has) && !handles.includes(rule.product.handle)) {
      return { ...rule, type: 'stack' };
    }
  }

  for (const rule of SINGLE_PRODUCT_UPGRADES) {
    if (handles.includes(rule.product.handle)) continue;

    const triggerItem = cart.items.find((item) => rule.triggers.includes(item.handle));
    if (!triggerItem) continue;

    const variantId = rule.product.variantByTitle?.[triggerItem.variant_title] || rule.product.variantId;
    return { ...rule, product: { ...rule.product, variantId }, type: 'bundle' };
  }

  if (JUG_TRIGGERS.some((handle) => handles.includes(handle)) && !handles.includes(PRODUCTS.jug.handle)) {
    return {
      type: 'accessory',
      title: "Don't forget the jug",
      text: 'Mix it, carry it, stay hydrated through your session.',
      button: 'Add jug',
      product: PRODUCTS.jug,
    };
  }

  return null;
}

function findFreeShippingOffer(cart) {
  if (!cart?.items?.length || cart.total_price >= FREE_SHIPPING_THRESHOLD) return null;

  const handles = getCartHandles(cart);
  const product = LOW_COST_ADD_ONS.find((item) => !handles.includes(item.handle));
  if (!product) return null;

  const formatter = new Intl.NumberFormat('en-GB', { style: 'currency', currency: 'GBP' });
  const amount = formatter.format((FREE_SHIPPING_THRESHOLD - cart.total_price) / 100);

  return {
    type: 'shipping',
    title: `You're ${amount} away from free shipping`,
    text: 'Add a daily essential and unlock free delivery.',
    button: 'Add and unlock',
    product,
  };
}

function getCartOffers(cart) {
  const offers = [];
  const primary = findPrimaryCartOffer(cart);
  const shipping = findFreeShippingOffer(cart);

  if (primary) offers.push(primary);
  if (shipping && shipping.product.handle !== primary?.product?.handle) offers.push(shipping);

  return offers.slice(0, 2);
}

function renderCartOffer(offer) {
  const product = offer.product;

  return `
    <article class="cart-bundle-upsell__card" data-upsell-type="${offer.type}">
      <a class="cart-bundle-upsell__media" href="${product.url}" aria-label="${product.title}">
        <img src="${product.image}" alt="" loading="lazy" width="72" height="72">
      </a>
      <div class="cart-bundle-upsell__content">
        <p class="cart-bundle-upsell__eyebrow">${product.subtitle || 'Bundle upgrade'}</p>
        <h3 class="cart-bundle-upsell__title">${offer.title}</h3>
        <p class="cart-bundle-upsell__text">${offer.text}</p>
        <div class="cart-bundle-upsell__actions">
          <a class="cart-bundle-upsell__link" href="${product.url}">${product.price}</a>
          <button class="button cart-bundle-upsell__button" type="button" data-upsell-add data-variant-id="${product.variantId}">
            ${offer.button}
          </button>
        </div>
      </div>
    </article>
  `;
}

async function syncBundleUpsell() {
  try {
    const summary = document.querySelector('cart-drawer-component .cart__summary-totals');
    const existing = document.querySelector('cart-bundle-upsell');

    if (!summary) {
      existing?.remove();
      return;
    }

    const response = await fetch('/cart.js');
    const cart = await response.json();
    const offers = getCartOffers(cart);

    if (!offers.length) {
      existing?.remove();
      return;
    }

    let upsell = existing;
    if (!upsell) {
      upsell = document.createElement('cart-bundle-upsell');
      upsell.className = 'cart-bundle-upsell cart-primary-typography';
      const freeShipping = summary.querySelector('free-shipping-countdown');
      summary.insertBefore(upsell, freeShipping?.nextSibling || summary.firstChild);
    }

    upsell.innerHTML = offers.map(renderCartOffer).join('');
    ensureUpsellStyles();
  } catch (error) {
    document.querySelector('cart-bundle-upsell')?.remove();
  }
}

function injectProductPageUpsells() {
  const match = window.location.pathname.match(/\/products\/([^/?#]+)/);
  if (!match || document.querySelector('.product-stack-upsell')) return;

  const handle = match[1];
  const config = PRODUCT_PAGE_RECOMMENDATIONS[handle];
  if (!config) return;

  const reviewTarget = document.querySelector(
    '[class*="loox"], [id*="loox"], .jdgm-widget, [data-oke-widget], [class*="reviews"][class*="dynamic"]'
  );
  const target =
    reviewTarget ||
    document.querySelector('[id^="shopify-section"][id*="product-information"]') ||
    document.querySelector('[id^="shopify-section-template"][id*="product"]') ||
    document.querySelector('main');

  if (!target) return;

  const section = document.createElement('section');
  section.className = 'product-stack-upsell page-width';
  section.innerHTML = renderProductPageUpsell(config);

  if (reviewTarget) {
    reviewTarget.insertAdjacentElement('beforebegin', section);
  } else {
    target.insertAdjacentElement('afterend', section);
  }

  ensureUpsellStyles();
}

function renderProductPageUpsell(config) {
  const primary = config.primary
    ? `
      <a class="product-stack-upsell__hero" href="${config.primary.url}">
        <img src="${config.primary.image}" alt="" loading="lazy" width="96" height="96">
        <span>
          <strong>${config.cta}</strong>
          <small>${config.primary.subtitle}</small>
        </span>
      </a>
    `
    : '';

  const cards = config.items
    .map(
      (item) => `
        <article class="product-stack-upsell__card">
          <a href="${item.url}" class="product-stack-upsell__image">
            <img src="${item.image}" alt="" loading="lazy" width="120" height="120">
          </a>
          <div>
            <h3>${item.title}</h3>
            <p>${item.subtitle}</p>
            <a href="${item.url}">${item.price}</a>
          </div>
        </article>
      `
    )
    .join('');

  return `
    <div class="product-stack-upsell__inner">
      <div class="product-stack-upsell__header">
        <h2>${config.title}</h2>
        <p>${config.intro}</p>
        ${primary}
      </div>
      <div class="product-stack-upsell__grid">${cards}</div>
    </div>
  `;
}

function ensureUpsellStyles() {
  if (document.getElementById('pantheon-upsell-styles')) return;

  const style = document.createElement('style');
  style.id = 'pantheon-upsell-styles';
  style.textContent = `
    .cart-bundle-upsell {
      display: grid;
      gap: var(--gap-xs);
      width: calc(100% - (var(--padding-sm) * 2));
      margin-inline: var(--padding-sm);
    }

    .cart-bundle-upsell__card {
      display: grid;
      grid-template-columns: 3.25rem minmax(0, 1fr);
      gap: var(--gap-xs);
      width: 100%;
      padding: 0.65rem;
      border: 1px solid var(--color-border);
      border-radius: var(--style-border-radius-inputs);
      background: rgb(var(--color-foreground-rgb) / 0.04);
    }

    .cart-bundle-upsell__media,
    .product-stack-upsell__image {
      overflow: hidden;
      align-self: start;
      aspect-ratio: 1;
      border-radius: calc(var(--style-border-radius-inputs) * 0.75);
      background: var(--color-background);
    }

    .cart-bundle-upsell__media img,
    .product-stack-upsell img {
      display: block;
      width: 100%;
      height: 100%;
      object-fit: cover;
    }

    .cart-bundle-upsell__eyebrow,
    .cart-bundle-upsell__title,
    .cart-bundle-upsell__text,
    .product-stack-upsell h2,
    .product-stack-upsell h3,
    .product-stack-upsell p {
      margin: 0;
    }

    .cart-bundle-upsell__eyebrow {
      margin-block-end: var(--margin-3xs);
      color: rgb(var(--color-foreground-rgb) / var(--opacity-subdued-text));
      font-size: 0.7rem;
      line-height: 1.1;
      text-transform: uppercase;
    }

    .cart-bundle-upsell__title {
      font-size: 0.82rem;
      line-height: 1.1;
    }

    .cart-bundle-upsell__text {
      margin-block-start: var(--margin-3xs);
      font-size: 0.82rem;
      line-height: 1.22;
    }

    .cart-bundle-upsell__actions {
      display: flex;
      flex-wrap: wrap;
      align-items: center;
      gap: 0.45rem;
      margin-block-start: 0.55rem;
    }

    .cart-bundle-upsell__link {
      color: currentColor;
      font-size: 0.82rem;
      font-weight: var(--font-weight-bold);
      text-decoration: none;
    }

    .cart-bundle-upsell__button {
      min-height: 2.05rem;
      padding-inline: 0.75rem;
      font-size: 0.76rem;
      line-height: 1;
    }

    .product-stack-upsell {
      box-sizing: border-box;
      width: min(100%, var(--page-width, 1200px));
      margin-inline: auto;
      padding: clamp(2rem, 5vw, 4rem) max(1rem, var(--padding-xl, 2rem));
    }

    .product-stack-upsell__inner {
      display: grid;
      grid-template-columns: minmax(18rem, 0.8fr) minmax(0, 1.5fr);
      gap: clamp(1.5rem, 4vw, 3rem);
      align-items: start;
    }

    .product-stack-upsell__header {
      display: grid;
      gap: var(--gap-md);
    }

    .product-stack-upsell__header h2 {
      font-size: clamp(1.5rem, 3vw, 2rem);
      line-height: 1.1;
    }

    .product-stack-upsell__header p,
    .product-stack-upsell__card p {
      color: rgb(var(--color-foreground-rgb) / var(--opacity-subdued-text));
      line-height: 1.45;
    }

    .product-stack-upsell__hero,
    .product-stack-upsell__card {
      display: grid;
      grid-template-columns: 5rem minmax(0, 1fr);
      gap: var(--gap-md);
      align-items: center;
      padding: var(--padding-md);
      border: 1px solid var(--color-border);
      border-radius: var(--style-border-radius-inputs);
      color: currentColor;
      text-decoration: none;
      background: rgb(var(--color-foreground-rgb) / 0.04);
    }

    .product-stack-upsell__hero img {
      aspect-ratio: 1;
      border-radius: calc(var(--style-border-radius-inputs) * 0.75);
      background: var(--color-background);
    }

    .product-stack-upsell__hero span,
    .product-stack-upsell__card div {
      display: grid;
      gap: var(--gap-2xs);
    }

    .product-stack-upsell__hero small {
      color: rgb(var(--color-foreground-rgb) / var(--opacity-subdued-text));
    }

    .product-stack-upsell__grid {
      display: grid;
      grid-template-columns: repeat(auto-fit, minmax(min(100%, 18rem), 1fr));
      gap: var(--gap-md);
    }

    .product-stack-upsell__card {
      grid-template-columns: 5.75rem minmax(0, 1fr);
      align-items: start;
      min-width: 0;
    }

    .product-stack-upsell__card h3 {
      font-size: 1rem;
      line-height: 1.2;
      overflow-wrap: normal;
      word-break: normal;
    }

    .product-stack-upsell__card a {
      color: currentColor;
      font-weight: var(--font-weight-bold);
      text-decoration: none;
    }

    @media screen and (max-width: 749px) {
      .cart-bundle-upsell__card {
        grid-template-columns: 3rem minmax(0, 1fr);
      }

      .cart-bundle-upsell__button {
        width: auto;
      }

      .product-stack-upsell__inner,
      .product-stack-upsell__grid {
        grid-template-columns: 1fr;
      }

      .product-stack-upsell__card {
        grid-template-columns: 5rem minmax(0, 1fr);
      }
    }
  `;

  document.head.appendChild(style);
}

function ensureProductCardPriceStyles() {
  if (document.getElementById('pantheon-product-card-price-styles')) return;

  const style = document.createElement('style');
  style.id = 'pantheon-product-card-price-styles';
  style.textContent = `
    product-card .price,
    .product-card .price,
    .card-product .price,
    .product-grid .price,
    .collection .price,
    .featured-collection .price {
      justify-content: center;
      text-align: center;
    }

    product-card .price__container,
    .product-card .price__container,
    .card-product .price__container,
    .product-grid .price__container,
    .collection .price__container,
    .featured-collection .price__container {
      justify-content: center;
      text-align: center;
      width: 100%;
    }

    product-card .price__sale,
    product-card .price__regular,
    .product-card .price__sale,
    .product-card .price__regular,
    .card-product .price__sale,
    .card-product .price__regular,
    .product-grid .price__sale,
    .product-grid .price__regular,
    .collection .price__sale,
    .collection .price__regular,
    .featured-collection .price__sale,
    .featured-collection .price__regular {
      display: inline-flex;
      justify-content: center;
      gap: 0.5rem;
      width: 100%;
    }
  `;

  document.head.appendChild(style);
}

document.addEventListener(CartAddEvent.eventName, syncBundleUpsell);
document.addEventListener(ThemeEvents.cartUpdate, syncBundleUpsell);
document.addEventListener(ThemeEvents.discountUpdate, syncBundleUpsell);
document.addEventListener('DOMContentLoaded', () => {
  ensureProductCardPriceStyles();
  syncBundleUpsell();
  injectProductPageUpsells();
});
